export function prettyFormatAmount(amount: number): string {
  return new Intl.NumberFormat("no-NB", { style: "currency", currency: "NOK" }).format(amount)
}
